window.app = window.app || {};
window.app.cw = window.app.cw || {};
window.app.cw.common = window.app.cw.common || {};

app.cw.common.FormatString = {
    currency: function currency(amount) {
        var result = '';
        var formatAmount = Math.abs(amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        if (amount < 0) {
            result = '-$' + formatAmount;
        }
        else {
            result = '$' + formatAmount;
        }
        return result;
    },
    shortCurrency: function shortCurrency(value) {
        if (value > 999999999999) { // trillions
            value = '$' + (value / 1000000000000) + 'T';
        }
        else if (value > 999999999 && value < 999999999999) { // billions
            value = '$' + (value / 1000000000) + 'B';
        }
        else if (value > 999999 && value < 999999999) { // millions
            value = '$' + (value / 1000000) + 'M';
        }
        else if (value > 999 && value < 999999) { // thousands
            value = '$' + (value / 1000) + 'K';
        }
        else if (value > 0 && value < 999) {
            value = '$' + value;
        }
        else if (value > -999999 && value < 0) {
            value = '-$' + Math.abs(value / 1000) + 'K';
        }
        else if (value > -999999999 && value < -999999) {
            value = '-$' + Math.abs(value / 1000000) + 'M';
        }
        else if (value > -999999999999 && value < -999999999) {
            value = '-$' + Math.abs(value / 1000000000000) + 'B';
        }
        else {
            value = '$' + value;
        }
        return value;
    },
    truncate: function truncate(fullTextString, maxLength) {
        var format = '';
        maxLength = isNaN(maxLength) ? 100 : maxLength;

        if (fullTextString !== null) {
            if (fullTextString.length >= maxLength) {
                format = fullTextString.substring(0, maxLength) + '...';
            }
            else {
                format = fullTextString;
            }
        }
        return format;
    },
    percentage: function percentage(value, decimal) {
        const isNegative = value < 0;

        if (decimal != null) {
            decimal = parseInt(decimal);
            value = Math.abs(value).toFcwed(decimal);
        }

        const markup = isNegative
            ? '-' + Math.abs(value) + '%'
            : value + '%'

        return markup;
    },
    phone: function phone(phoneString, removeLink) {
        var phoneFormat = '';

        if (phoneString !== null) {
            // Format string as phone number (ex. 123-456-7890)
            phoneFormat = phoneString.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            phoneFormat = removeLink ? phoneFormat : '<a href="tel:' + phoneFormat + '">' + phoneFormat + '</a>';
        }
        return phoneFormat;
    },
    removeSpecialChar: function removeSpecialChar(string) {
        var stringFormat = '';
        if (string !== null) {
            stringFormat = string.replace(/[^a-zA-Z0-9]/g, '');
        }
        return stringFormat;
    },
    ssn: function ssn(ssnString) {
        var ssnFormat = '';
        if (ssnString !== null) {
            // Format string as ssn (ex. 123-45-6789)
            ssnFormat = ssnString.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
        }
        return ssnFormat;
    },
    titleCase: function titleCase(string) {
        var titleCaseFormat = '';
        if (string !== null) {
            // Format string as title case (ex. Title Case)
            titleCaseFormat = string.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        }
        return titleCaseFormat;
    }
};